module.exports = __webpack_public_path__ + "pintora/latch-55f5b1ce17b8658f.svg";